import React from 'react'

const AttachmentsEmpty = () => (
  <div className="attachments-section">
    <span className="no-attachments-message">
      No attachments
    </span>
  </div>
)

export default AttachmentsEmpty
